/*
 * @Author: your name
 * @Date: 2020-10-31 14:59:46
 * @LastEditTime: 2020-10-31 17:04:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\fe-mall\components\eventBus.js
 */
import Vue from 'vue'
export default new Vue()
